import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import * as Actions from '../../actions';
import DropdownBox from '../../components/Dropdown/DropdownBox/DropdownBox';
import Option from '../../components/Dropdown/DropdownOption/DropdownOption';
import * as Constants from '../../constants';
import { getInDomain } from '../../domains/externalUtils';

export const ShuffleToggleDropdownKey = Symbol('ShuffleToggleDropdown');

class ShuffleToggleDropdown extends React.Component {
  static propTypes = {
    childProps: PropTypes.object.isRequired,
    closeDropdown: PropTypes.func,
    addAllToShuffle: PropTypes.func,
    isShufflingAll: PropTypes.bool,
    dropdownType: PropTypes.any,
    restorePreviousShuffle: PropTypes.func,
    enableCustom: PropTypes.bool,
    intl: PropTypes.object,
  };

  getSettings = () => {
    return [
      {
        label: <FormattedMessage {...Constants.MyStations.messages.shuffleAll} />,
        callback: () => {
          this.props.addAllToShuffle();
        },
        isSelected: this.props.isShufflingAll,
      },
      {
        label: <FormattedMessage {...Constants.MyStations.messages.custom} />,
        callback: () => {
          if (this.props.isShufflingAll) {
            // we only restore previous shuffle if currently shuffling all
            this.props.restorePreviousShuffle();
          }
        },
        isSelected: !this.props.isShufflingAll,
        disabled: !this.props.enableCustom,
      },
    ];
  };

  render() {
    const settings = this.getSettings();
    const options = settings.map(({ label, callback, isSelected, disabled }, i) => {
      const optionProps = {
        callback,
        label,
        isSelected,
        disabled,
        isSelectable: true,
        key: `shuffleToggleOption${i}`,
        extrasStyles: ['DropdownOption--shuffle'],
      };

      return <Option key={i} {...optionProps} />;
    });

    return <DropdownBox menuType={this.props.dropdownType}>{options}</DropdownBox>;
  }
}

export function mapStateToProps(state) {
  const isShufflingAll = getInDomain('playback.utils.isInShuffleAllMode')(state);
  return {
    isShufflingAll,
    enableCustom: !isShufflingAll || getInDomain('playback.utils.canPlayPreviousShuffle')(state),
  };
}

const connectedShuffleToggle = connect(mapStateToProps, {
  addAllToShuffle: Actions.Playback.addAllEligibleStationsToShuffle,
  restorePreviousShuffle: Actions.Playback.restorePreviousShuffle,
})(ShuffleToggleDropdown);

export const constructors = {
  [ShuffleToggleDropdownKey]: connectedShuffleToggle,
};
